import { render, staticRenderFns } from "./RePWDSuccess.vue?vue&type=template&id=41b6a319&scoped=true&"
import script from "./RePWDSuccess.vue?vue&type=script&lang=js&"
export * from "./RePWDSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b6a319",
  null
  
)

export default component.exports